
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import WhyBodeStoreName from '@/store/why-bode/name';
import routes from '@/constants/routes';
import { WhyBodeTrackEvent } from '@/constants/AnalyticEvents';
import WhyBodeSection from '../section';

export default {
  name: 'WhyBodeFooterSection',
  components: {
    Typography,
    WhyBodeSection,
    Gutter,
    Button,
  },
  data() {
    return {
      TypographyType,
      StylePositionType,
      StyleColorSchemeType,
      StyleSizeType,
      routes,
      WhyBodeTrackEvent,
    };
  },
  computed: {
    footerContent() {
      return this.$store.state[WhyBodeStoreName].footerContent;
    },
  },
};
